<template>
    <div class="recommend">
        <scroll ref="scrollCom" class="recommend-content" :data="hot_comment_list">
            <div>
                <div class='iNews_main'>
                    <div class='foot_main'>
                        <div class='foot_logo'>
                            <img :src="logo" alt="" />
                            <span>专业股市投资者社区</span>
                        </div>
                        <a href='https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui' class='download'>下载</a>
                    </div>
                    <div class='iNews_contain'>
                        <div v-if="!loading" class='iNews_content'>
                            <span class='iNews_content_time'>{{data.rec_time_desc&&data.rec_time_desc.split(' ')[1].toString()}}</span>
                            <span v-html="data.content_link"></span>
                        </div>
                        <skeleton-screen v-if="loading" :data="1"></skeleton-screen>
                        <div v-if="data.o_title" @click="jumptolive(data.o_id)" class='iNews_detail'>
                            <img src="https://cdn.aigupiao.com/static/wrap/img/deep_link_ico.png" alt="" />{{data.o_title}}</div>
                        <!-- todo -->
                        <div v-if="data.small_video" class='small_video'>
                            <div class='vedio_img'>
                                <span class='vedio_image'>
                                    <img class='vedio_image_img' :src="data.small_video.video_img" alt="" />
                                    <!-- todo -->
                                    <p @click="clickPlay(data.small_video.video)"><img class='vedio_play' src="https://cdn.aigupiao.com/static/wrap/img/media_play_ico.png" alt="" />
                                        <span class='vedio_time ub align-items'>
                                            <img class='vedio_time_icon' src="https://cdn.aigupiao.com/static/wrap/img/small_video_ico1.png" alt="" />
                                            <i>{{data.small_video.video_len}}</i>
                                        </span>
                                    </p>
                                </span>
                            </div>
                        </div>
                        <div v-if="!data.small_video&&images.length" :class="gitClass(images)">
                            <img v-for="citemData,cindex in images" @load="$previewRefresh" v-bind:key="cindex" :preview="randomStr" class="iNews_img1" :src="`${citemData}`" alt="图片" />
                        </div>
                        <div class='iNews_info'>
                            <span class='iNews_info_left'>{{data.formatDate}} {{data.rec_time_desc&&data.rec_time_desc.substr(data.rec_time_desc.indexOf('星期'))}}</span>
                            <span class='iNews_info_right'>阅 {{data.view_num}}</span>
                        </div>
                        <div class='iNews_like'>
                            <span @click="likeClick(data)">
                                <img :src="data.isLike?'https://cdn.aigupiao.com/static/wrap/img/detail_like8.png':'https://cdn.aigupiao.com/static/wrap/img/detail_like7.png'" alt="" />
                                <p class="num">{{data.support_num}}</p>
                            </span>
                            <span @click="unlikeClick(data)">
                                <img :src="data.unIsLike?'https://cdn.aigupiao.com/static/wrap/img/detail_like10.png':'https://cdn.aigupiao.com/static/wrap/img/detail_like9.png'
                                " alt="" />
                                <p class="num">{{data.oppose_num}}</p>
                            </span>
                        </div>
                        <div class='iNews_statement'>
                            <div class='iNews_contactUs'>
                                <a href="http://mobile.aigupiao.com/System/contactUs?jumpType=wap">联系我们 <img src="https://cdn.aigupiao.com/static/wrap/img/lianxiwomen_jiantou@2x.png" alt="" /></a>
                            </div>
                        </div>
                    </div>
                    <p class='iNews_statement_statement'>此内容不代表爱股票观点、仅供参考，不构成投资建议。投资者据此操作，风险自担</p>
                    <p class='iNews_jiange'></p>
                    <div class='articles_comment' id='comment'>
                        <div v-if="hot_comment_list.length" class='articles_hotComment'>
                            <h3 class='articles_commonTitle'><span></span>精彩评论</h3>
                            <ul>
                                <li v-for="item in  hot_comment_list" :key="item.id">
                                    <div class='articles_userName'>
                                        <img :src="item.u_avatar" alt="" />
                                    </div>
                                    <div class='articles_comment_content ub-f1 ub'>
                                        <div class="ub-f1">
                                            <div class='comment_title'>
                                                <h4>{{item.u_name}} </h4>
                                                <span class="ub align-items" @click="likeClick(item,'hot_comment_list')">
                                                    <img :src="item.isLike? zanle : zan" alt="" />
                                                    <span class="support_num">{{item.support_num}}</span>
                                                </span>
                                            </div>
                                            <div class='comment_con'>
                                                <p :class="item.unfold ? 'common_content_unfold' : 'common_content'" v-html="getContent(item.content, item.unfold)"></p>
                                                <p v-if="item.content.length>65&&!item.unfold" class='comment_unfold' @click="handlerExpandClick(item)">
                                                    <span>{{item.unfold}}展开</span>
                                                    <svg t="1563158745763" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1796" width="112" height="112">
                                                        <path d="M512 793.6c-12.8 0-21.333333-4.266667-29.866667-12.8L29.866667 328.533333c-17.066667-17.066667-17.066667-42.666667 0-59.733333s42.666667-17.066667 59.733333 0l422.4 422.4 277.333333-277.333333c17.066667-17.066667 42.666667-17.066667 59.733334 0s17.066667 42.666667 0 59.733333l-307.2 307.2c-8.533333 8.533333-17.066667 12.8-29.866667 12.8zM925.866667 379.733333c-12.8 0-21.333333-4.266667-29.866667-12.8-17.066667-17.066667-17.066667-42.666667 0-59.733333l38.4-38.4c17.066667-17.066667 42.666667-17.066667 59.733333 0s17.066667 42.666667 0 59.733333l-38.4 38.4c-8.533333 8.533333-21.333333 12.8-29.866666 12.8z" fill="#D8D8D8" p-id="1797"></path>
                                                    </svg>
                                                </p>
                                            </div>
                                            <a class='common_reply' href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui">
                                                {{item.rec_time_desc}} . 回复Ta
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class='articles_hotComment'>
                            <h3 class='articles_commonTitle'><span></span>全部评论</h3>
                            <ul>
                                <li v-for="item,index in comment_list" :key="item.id">
                                    <div class='articles_userName'>
                                        <img :src="item.u_avatar" alt="" />
                                    </div>
                                    <div class='articles_comment_content ub ub-f1'>
                                        <div class="ub-f1">
                                            <div class='comment_title'>
                                                <h4>{{item.u_name}}</h4>
                                                <span class="ub align-items" @click="likeClick(item, 'comment_list')">
                                                    <img :src="item.isLike? zanle : zan" alt="" />
                                                    <span class="support_num">{{item.support_num}}</span>
                                                </span>
                                            </div>
                                            <div class='comment_con'>
                                                <p :class="item.unfold?'common_content_unfold':'common_content'" v-html="getContent(item.content, item.unfold)"></p>
                                                <!-- {item.content.length>65&&item.ubfold&&!unfold&& -->
                                                <p v-if="item.content.length>65&&!item.unfold" class='comment_unfold' @click="handlerExpandClick(item)">
                                                    <span>展开</span>
                                                    <svg t="1563158745763" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1796" width="112" height="112">
                                                        <path d="M512 793.6c-12.8 0-21.333333-4.266667-29.866667-12.8L29.866667 328.533333c-17.066667-17.066667-17.066667-42.666667 0-59.733333s42.666667-17.066667 59.733333 0l422.4 422.4 277.333333-277.333333c17.066667-17.066667 42.666667-17.066667 59.733334 0s17.066667 42.666667 0 59.733333l-307.2 307.2c-8.533333 8.533333-17.066667 12.8-29.866667 12.8zM925.866667 379.733333c-12.8 0-21.333333-4.266667-29.866667-12.8-17.066667-17.066667-17.066667-42.666667 0-59.733333l38.4-38.4c17.066667-17.066667 42.666667-17.066667 59.733333 0s17.066667 42.666667 0 59.733333l-38.4 38.4c-8.533333 8.533333-21.333333 12.8-29.866666 12.8z" fill="#D8D8D8" p-id="1797"></path>
                                                    </svg>
                                                </p>
                                            </div>
                                            <a class='common_reply' href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui">
                                                {{item.rec_time_desc}} . 回复Ta
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-if="hot_comment_list.length || comment_list.length" class='articles_openApp'>
                            <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui">打开爱股票app，查看全部{{data.comment_num}}条评论></a>
                        </div>
                        <div v-else class='go_comment'>目前没有评论，<a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui">去评论</a></div>
                        <div class='articles_goodRecommend'>
                            <h3 class='articles_commonTitle'><span></span>精彩推荐</h3>
                            <ul>
                                <li v-for="recommend,index in goodRecommend" :key="recommend.o_id" @click="handlerWonderfulClick(index, recommend.o_id)">
                                    <div class='articles_goodRecommend_top'>
                                        <h3>{{recommend.title}}</h3>
                                        <p></p>
                                    </div>
                                    <div class='articles_goodRecommend_bottom'>
                                        <p class='recommend_bottom_left ub align-items'>
                                            <img :src="recommend.imgUrl" alt="" />
                                            <a>
                                                <span class='recommend_bottom_one'>{{recommend.source}}</span>
                                                <span class='recommend_bottom_two'>{{recommend.rec_time}}</span>
                                            </a>
                                        </p>
                                        <p class='recommend_bottom_right'>
                                            <a v-if="(index+1)%2>0"><img src="https://cdncos.aigupiao.com/assets/pc/img/go_aigupiao@2x.png" alt="" /></a>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </scroll>
    </div>
</template>
<script>
import NewsApi from '@/api/importantNews/';
import logo from '@/assets/images/aiguplogo2x.png'
import zan from '@/assets/images/icon-good-gray@2x.png'
import zanle from '@/assets/images/icon-good-red@2x.png'
import PublicApi from '@/api/publicApi/';
import moment from 'moment';
import Scroll from '@/base/scroll/index'

export default {
    name: 'Column',
    components: {
        Scroll
    },
    data() {
        return {
            id: this.$route.params.id,
            hash: this.$route.hash,
            kind: 'express',
            logo,
            zan,
            zanle,
            images: [],
            data: {
                support_num: 0,
                oppose_num: 0,
                comment_num: 0,
            },
            hot_comment_list: [],
            comment_list: [],
            likeId: '',
            bool: '',
            unLikeId: '',
            unBool: '',
            unfold: '',
            loading: true,
            goodRecommend: [],
            randomStr: Math.random().toString(36).slice(-4)
        };
    },
    created() {
        this.init()
    },

    methods: {
        // 获取要闻详情数据
        init() {
            const promises = [NewsApi.getImportNewsDetail(this.id), NewsApi.getComment(this.id, this.kind), NewsApi.getGoodRecommend()]
            Promise.all(promises).then(res => {
                this.importNewsDetailApi(res[0])
                this.comment_list = res[1].comment_list
                this.hot_comment_list = res[1].hot_comment_list
                this.goodRecommend = res[2];
                setTimeout(() => {
                    this.$refs.scrollCom.refresh()
                    setTimeout(() => {
                        this.$refs.scrollCom.scrollToElement(this.hash, 300)
                    }, 120);
                }, 150);

            });
        },
        getContent(con, state) {
            if (state) {
                return con
            } else {
                return con.replace(/<br>/g, '')
            }
        },
        gitClass(images) {
            if (images.length === 3) {
                return 'multimedia space-between'
            } else if (images.length === 1) {
                return 'iNew_img_many'
            } else {
                return 'multimedia'
            }
        },
        async importNewsDetailApi(data) {
            // let data = await NewsApi.getImportNewsDetail(this.id);
            data.data.formatDate = moment(data.data.rec_time).format('YYYY-MM-DD')
            if (data.data.small_video) {
                data.data.small_video = JSON.parse(data.data.small_video)
            }
            this.loading = false
            // 分享
            this.$share(data.share)

            this.data = data.data
            let images = []
            if (data.data.image_1) {
                images.push(data.data.image_1)
            }
            if (data.data.image_2) {
                images.push(data.data.image_2)
            }
            if (data.data.image_3) {
                images.push(data.data.image_3)
            }
            this.images = images

        },
        // 获取要闻详情页评论列表数据
        async importNewsDetailsCommentApi() {
            let comment = await NewsApi.getComment(this.id, this.kind);
            this.comment_list = comment.comment_list
            this.hot_comment_list = comment.hot_comment_list

        },
        // 推荐
        async importNewsGoodRecommendApi() {
            this.goodRecommend = await NewsApi.getGoodRecommend();

        },
        // 获取分享接口数据
        async shareApi() {
            this.shareData = await NewsApi.getShare();
        },
        clickPlay(src) {
            this.$videoplay.open(src)
            // this.props.importantNews.vedioUrl = vedioUrl
            // this.props.importantNews.vedioPlay = true
        },
        anchorJump(seletor) {
            if (!this.hash) return
            const anchorEle = document.querySelector(seletor);
            if (anchorEle) {
                anchorEle.scrollIntoView(true);
            }
        },
        selectAlbumItem(data, index, className) {
            this.$photoswipe.open(index, data, className)
        },
        jumptolive(id) {
            // this.props.history.push(`/liveDetail/${id}`)
            window.location.href = `/news/detail/id/${ id }` //跳转老项目

            // window.location.href = `/Lives/detail/id/${ id }` //跳转老项目
        },
        handlerWonderfulClick(index, id) {
            if ((index + 1) % 2 === 1) {
                window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui'
                return
            }
            // window.location.href = `https://mobiledev.aigupiao.com/lives/detail/id/${id}/jump_type/1.html`;
            window.location.href = `/lives/detail/id/${id}/jump_type/1.html`;
        },
        handlerExpandClick(item) {
            this.$set(item, 'unfold', !item.unfold)
        },
        likeClick(item) {
            if (item.isLike || item.unIsLike) return
            this.$set(item, 'isLike', !item.isLike)
            this.$set(item, 'support_num', parseInt(item.support_num) + 1)
            PublicApi.addPraise(item.id, 'express')
        },
        unlikeClick(item) {
            if (item.unIsLike || item.isLike) return
            this.$set(item, 'unIsLike', !item.unIsLike)
            this.$set(item, 'oppose_num', parseInt(item.oppose_num) + 1)
            PublicApi.reduce(item.id, 'express');

        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.border-1px(@color: #ccc, @radius: 0PX, @style: solid) {
    position: relative;

    &::after {
        content: "";
        pointer-events: none;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        border-bottom: 1PX @style @color;
        border-radius: @radius;
        box-sizing: border-box;
        width: 100%;
        height: 100%;

        @media (min-resolution: 2dppx) {
            width: 200%;
            height: 200%;
            border-radius: @radius * 2;
            transform: scale(.5);
        }

        @media (min-resolution: 3dppx) {
            width: 300%;
            height: 300%;
            border-radius: @radius * 3;
            transform: scale(.333);
        }
    }
}

.recommend {
    position: fixed;
    overflow: auto;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: #F0F0F0;
}

.recommend-content {
    height: 100%;
    overflow: hidden;
}

.foot_main {
    // width: 100%;
    height: 46px;
    background-color: #FFFFFF;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 0 2px 0 #BEBEBE;
    .foot_logo {
        height: 21px;
        display: flex;
        align-items: center;

        img {
            height: 100%;
            width: 91px;
            padding-right: 9px;
            border-right: 2px solid #E94444;
        }

        span {
            color: #EB2425;
            font-size: 12px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            margin-left: 9px;
        }
    }

    .download {
        width: 57px;
        height: 28px;
        background-color: #FE484A;
        color: #FFFFFF;
        font-size: 13px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        border-radius: 14px;
        text-align: center;
        line-height: 28px;
    }
}


.iNews_main {
    background-color: #FFFFFF;
    height: 100%;
    width: 100%;
    overflow: auto;

    .iNews_contain {
        .border-1px(#E8E8E8);

        .iNews_header {
            .border-1px(#E8E8E8);
            width: 100%;
            height: 43px;
            padding: 10px 12px;

            >img {
                width: 70px;
                height: 23px;
            }

            >ul {
                display: inline;

                li {
                    height: 14px;
                    margin-left: 23px;
                    font-size: 14px;
                    color: #434343;
                    display: inline;
                    font-family: PingFang-SC-Medium;
                    font-weight: 500;
                }
            }
        }

        .iNews_content {
            line-height: 25px;
            padding: 16px 13px;
            font-size: 16px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            display: block;
            text-align: justify;

            .iNews_content_time {
                color: #C7000A;
            }


        }

        .iNews_detail {
            color: #1C88D0;
            font-family: PingFang-SC-Medium;
            font-weight: 500;
            font-size: 13px;
            margin-left: 13px;
            display: flex;
            margin-bottom: 15px;

            img {
                width: 12px;
                height: 12px;
                margin-right: 3px;
            }
        }

        .iNew_img_many {
            padding: 0 12px;
            box-sizing: border-box;
            width: 100%;

            .iNews_img1 {
                width: 100%;
                height: 100%;
            }
        }

        .small_video {
            width: 100%;
            padding: 0 12px;
            box-sizing: border-box;

            .vedio_img {
                width: 100% !important;
                height: 197px;

                .vedio_image {
                    height: 100% !important;

                    .vedio_image_img {
                        height: 100% !important;
                        width: 100% !important;
                    }

                    p {
                        .vedio_play {


                            .vedio_time {
                                width: 63px;
                                height: 20px;

                                >img {
                                    width: 12px !important;
                                    height: 12px !important;
                                }
                            }
                        }
                    }
                }
            }
        }

        .multimedia {
            height: 100px;
            margin-top: 7px;
            margin-bottom: 7px;
            padding: 0 12px;
            display: flex;
            align-items: center;

            &.space-between {
                >img {
                    margin-right: 0;
                }
            }

            div {
                margin-right: 10px;
            }

            >img {
                width: 31%;
                margin-right: 10px;
                height: 100%;
            }
        }

        .iNews_img {
            display: flex;
            align-items: center;
            // width: 35%;
            height: 140px;
            padding: 0 12px;

            .iNews_img1 {
                width: 100%;
                height: 100%;
                margin-right: 10px;
            }
        }

        .iNews_info {
            padding: 21px 14px 0 12px;
            display: flex;
            justify-content: space-between;
            color: #898989;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
        }

        .iNews_like {
            display: flex;
            justify-content: center;
            padding: 28px 0 27px 0;

            span {
                width: 53px;
                margin: 0 14px;

                img {
                    width: 53px;
                    height: 53px;
                }

                p.num {
                    display: flex;
                    justify-content: center;
                    margin-top: 11px;
                    font-size: 15px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    color: rgba(147, 147, 147, 1);

                }
            }
        }

        .iNews_statement {
            .border-1px(#EBEBEB);
            padding-bottom: 19px;

            .iNews_contactUs {
                height: 31px;

                >a {
                    position: absolute;
                    right: 0;
                    display: inline-block;
                    width: 104px;
                    height: 34px;
                    border-radius: 15px 0 0 15px;
                    color: #282828;
                    font-size: 14px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    line-height: 34px;
                    text-align: center;
                    background-color: #F7F7F7;

                    >img {
                        width: 5px;
                        height: 8px;
                        margin-left: 11px;
                    }
                }
            }
        }
    }
}

.articles_comment {
    position: relative;

    .articles_hotComment {

        // padding-left: 12px;
        >ul {
            width: 100%;
            padding-top: 14px;

            >li {
                .border-1px(#E8E8E8);
                padding: 0 12px 36px 12px;
                display: flex;
                justify-content: space-between;

                &:last-child:after {
                    border-bottom: 0;
                }

                .articles_userName {
                    width: 36px;
                    height: 100%;
                    margin-right: 12px;

                    >img {
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        margin-top: 16px;
                    }
                }

                .articles_comment_content {
                    padding-top: 12px;
                    width: 100%;
                    display: block;
                    min-width: 0;

                    .support_num {
                        padding-top: 2px;
                        font-size: 12px;
                    }

                    .comment_title {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin: 10px 0 6px 0;

                        >h4 {
                            color: #999999;
                            font-size: 14px;
                            font-family: PingFangSC-Regular;
                            font-weight: 400;
                            width: 260px;
                        }

                        >span {
                            color: #999999;
                            font-size: 11px;
                            font-family: PingFangSC-Regular;
                            font-weight: 400;

                            >img {
                                width: 13px;
                                height: 12px;
                                margin-right: 6px;
                            }
                        }
                    }
                }
            }
        }
    }
}

.go_comment {
    width: 100%;
    height: 30px;
    margin-top: 6px;
    padding: 0 12px;
    box-sizing: border-box;
    color: #676767;
    font-size: 13px;
    line-height: 30px;
    font-family: PingFangSC-Regular;
    font-weight: 400;

    a {
        color: #1D88D0;
    }
}

.articles_commonTitle {
    color: #222222;
    font-size: 15px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    line-height: 18px;
    // vertical-align: middle;
    padding-left: 14px;
    padding-top: 14px;

    box-sizing: border-box;
    position: relative;

    >span {
        display: inline-block;
        width: 4px;
        height: 17px;
        background-color: #FE484A;
        left: 0;
        margin-right: 10px;
        position: absolute;

    }
}

.common_content {
    width: 100%;
    overflow: hidden;
    //最多3行显示
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    color: #505050;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 15px;
    margin-top: 5px;
    margin-bottom: 10px;
    word-wrap: break-word;
    line-height: 23px;
}

.common_content_unfold {
    width: 100%;
    color: #505050;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 15px;
    margin-top: 5px;
    margin-bottom: 10px;
    word-wrap: break-word;
    line-height: 23px;
}

.common_reply {
    font-size: 13px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #636363;
    line-height: 16px;
}

.comment_unfold {
    height: 18px;
    font-size: 15px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #939393;
    line-height: 18px;
    display: inline-block;
    margin-bottom: 10px;

    svg {
        width: 10px;
        height: 7px;
        margin-left: 6px;
        margin-bottom: 5px;
        ;
    }
}

.articles_openApp {
    width: 100%;
    height: 37px;
    padding: 0 12px;
    box-sizing: border-box;

    a {
        background-color: #EA5752;
        width: 100%;
        height: 100%;
        display: block;
        text-align: center;
        line-height: 37px;
        color: #ffffff;
        font-size: 15px;
    }
}

.iNews_statement_statement {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #939393;
    line-height: 19px;
    padding: 10px 14px;
}

.iNews_jiange {
    width: 100%;
    height: 10px;
    background: rgba(240, 240, 240, 1);
}

.live_contain {
    background-color: #FFFFFF;
    height: 100%;

    .live_content {
        height: 100%;
        width: 100%;
        position: relative;
        overflow: auto;

        // line-height: 25px;
        .live_content_content {
            overflow: hidden;
            max-height: 200%;
            position: absolute;
            // .border-1px(#E8E8E8);

            .live_title {
                padding-right: 18px;
                font-size: 20px !important;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #000000;
                width: 100%;
                height: 46px;
                margin-top: 12px;
            }

            .live_autor {
                width: 100%;
                height: 41px;
                margin: 14px 0;

                .live_autor_name {
                    width: 100%;
                    height: 100%;
                    color: #333333;
                    display: flex;
                    align-items: center;
                    font-size: 15px;

                    .live_autor_name_name {
                        margin-right: 19px;
                        font-family: PingFangSC-Semibold;
                        font-weight: 600;
                    }

                    .live_autor_time {
                        color: #939393;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                    }
                }
            }
        }

        .live_brief {
            font-size: 15px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #898989;
        }

        .live_content_cont {
            margin-top: 34px;
            overflow: hidden;
            font-size: 17px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            line-height: 25px;

        }

        .live_like {
            margin: 39px 0 30px 0;
            position: relative;
            height: 72px;

            >img {
                position: absolute;
                width: 45px;
                height: 45px;
                left: 0;
                right: 0;
                margin: auto;
            }

            >span {
                width: 16px;
                height: 11px;
                position: absolute;
                left: 0;
                right: 0;
                margin: auto;
                top: 55px;
                color: #898989;
                font-size: 14px;
                font-family: PingFang-SC-Medium;
                font-weight: 500;
            }
        }

        .live_statement {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #BFC0C1;
            line-height: 19px;
        }

        .live_contactUs {
            height: 31px;
            margin-top: 24px;

            >a {
                position: absolute;
                right: 0;
                display: inline-block;
                width: 93px;
                height: 31px;
                background: rgba(248, 247, 245, 1);
                border-radius: 15px;
                color: #282828;
                font-size: 12px;
                text-align: center;
                background-color: #F8F7F5;
                line-height: 31px;

                >img {
                    width: 5px;
                    height: 8px;
                }
            }
        }
    }
}

.live_commonTitle {
    color: #282828;
    font-size: 15px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;

    >span {
        display: inline-block;
        width: 3px;
        height: 18px;
        background-color: #EA5752;
        left: 0;
        margin-right: 12px;
    }
}

.live_openApp {
    width: 100%;
    height: 37px;
    padding: 0 12px;

    a {
        background-color: #EA5752;
        width: 100%;
        height: 100%;
        display: block;
        text-align: center;
        line-height: 37px;
        color: #ffffff;
        font-size: 15px;
    }
}

.live_action {
    position: absolute;
    .border-1px(#E8E8E8);
    padding: 0 12px 34px 12px;

    .live_title {
        padding-right: 12px;
        font-size: 20px !important;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #282828;
        width: 100%;
        height: 46px;
        margin-top: 12px;
    }

    .live_autor {
        position: relative;
        width: 100%;
        height: 41px;
        margin-top: 21px;
        margin-bottom: 21px;

        >img {
            width: 41px;
            height: 41px;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            margin: auto;
        }

        >div {
            height: 100%;
            position: absolute;
            left: 66px;

            .live_autor_name {
                span {
                    height: 15px;
                    margin-right: 4px;
                }

                img {
                    width: 18px;
                    height: 18px;
                }
            }

            .live_autor_time {
                height: 11px;
                color: #999999;
                font-size: 12px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                margin-top: 7px;

                span:nth-of-type(2) {
                    margin-left: 5px;
                }
            }
        }

        button {
            width: 65px;
            height: 26px;
            background-color: #EA5E58;
            border-radius: 4px;
            color: #ffffff;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            line-height: 26px;
            border: none;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
        }
    }

    .live_brief {
        font-size: 15px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #898989;
    }

    .live_content_cont {
        margin-top: 34px;
        overflow: hidden;
        font-size: 15px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
    }

    .live_like {
        margin: 39px 0 30px 0;
        position: relative;
        height: 72px;

        >img {
            position: absolute;
            width: 45px;
            height: 45px;
            left: 0;
            right: 0;
            margin: auto;
        }

        >span {
            width: 16px;
            height: 11px;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            top: 55px;
            color: #898989;
            font-size: 14px;
            font-family: PingFang-SC-Medium;
            font-weight: 500;
        }
    }

    .live_statement {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #BFC0C1;
    }

    .live_contactUs {
        height: 31px;
        margin-top: 24px;

        >a {
            position: absolute;
            right: 0;
            display: inline-block;
            width: 93px;
            height: 31px;
            background: rgba(248, 247, 245, 1);
            border-radius: 15px;
            color: #282828;
            font-size: 12px;
            text-align: center;
            background-color: #F8F7F5;
            line-height: 31px;

            >img {
                width: 5px;
                height: 8px;
            }
        }
    }
}

.live_unfold {
    height: 78px;
    width: 100%;
    // opacity: .04;
    position: absolute;
    bottom: -30px;
    background-image: linear-gradient(-180deg, hsla(0, 0%, 100%, 0), #fff);
}

.live_unfold_down {
    content: '';
    background-image: url(https://cdn.aigupiao.com/static/wrap/img/live_detail_ico5.png);
    background-repeat: no-repeat;
    background-size: contain;
    height: 16px;
    width: 16px;
    position: absolute;
    z-index: 99;
    animation: unfold-arrow-animation 300ms infinite alternate;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
}

@keyframes unfold-arrow-animation {
    from {
        bottom: 0;
    }

    to {
        bottom: 5px;
    }
}

.live_contain {
    background-color: #FFFFFF;
    height: 100%;

    .live_content {
        height: 100%;
        width: 100%;
        position: relative;
        overflow: auto;

        // line-height: 25px;
        .live_content_content {
            overflow: hidden;
            max-height: 200%;
            position: absolute;
            .border-1px(#E8E8E8);
            padding: 0 12px 34px 12px;

            .live_title {
                padding-right: 18px;
                font-size: 20px !important;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #000000;
                width: 100%;
                height: 46px;
                margin-top: 12px;
            }

            .live_autor {
                width: 100%;
                height: 41px;
                margin: 14px 0;

                .live_autor_name {
                    width: 100%;
                    height: 100%;
                    color: #333333;
                    display: flex;
                    align-items: center;
                    font-size: 15px;

                    .live_autor_name_name {
                        margin-right: 19px;
                        font-family: PingFangSC-Semibold;
                        font-weight: 600;
                    }

                    .live_autor_time {
                        color: #939393;
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                    }
                }
            }
        }

        .live_brief {
            font-size: 15px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #898989;
        }

        .live_content_cont {
            margin-top: 34px;
            overflow: hidden;
            font-size: 17px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            line-height: 25px;

        }

        .live_like {
            margin: 39px 0 30px 0;
            position: relative;
            height: 72px;

            >img {
                position: absolute;
                width: 45px;
                height: 45px;
                left: 0;
                right: 0;
                margin: auto;
            }

            >span {
                width: 16px;
                height: 11px;
                position: absolute;
                left: 0;
                right: 0;
                margin: auto;
                top: 55px;
                color: #898989;
                font-size: 14px;
                font-family: PingFang-SC-Medium;
                font-weight: 500;
            }
        }

        .live_statement {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #BFC0C1;
            line-height: 19px;
        }

        .live_contactUs {
            height: 31px;
            margin-top: 24px;

            >a {
                position: absolute;
                right: 0;
                display: inline-block;
                width: 93px;
                height: 31px;
                background: rgba(248, 247, 245, 1);
                border-radius: 15px;
                color: #282828;
                font-size: 12px;
                text-align: center;
                background-color: #F8F7F5;
                line-height: 31px;

                >img {
                    width: 5px;
                    height: 8px;
                }
            }
        }
    }
}

.live_commonTitle {
    color: #282828;
    font-size: 15px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;

    >span {
        display: inline-block;
        width: 3px;
        height: 18px;
        background-color: #EA5752;
        left: 0;
        margin-right: 12px;
    }
}

.live_openApp {
    width: 100%;
    height: 37px;
    padding: 0 12px;

    a {
        background-color: #EA5752;
        width: 100%;
        height: 100%;
        display: block;
        text-align: center;
        line-height: 37px;
        color: #ffffff;
        font-size: 15px;
    }
}

.live_action {
    position: absolute;
    .border-1px(#E8E8E8);
    padding: 0 12px 34px 12px;

    .live_title {
        padding-right: 12px;
        font-size: 20px !important;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #282828;
        width: 100%;
        height: 46px;
        margin-top: 12px;
    }

    .live_autor {
        position: relative;
        width: 100%;
        height: 41px;
        margin-top: 21px;
        margin-bottom: 21px;

        >img {
            width: 41px;
            height: 41px;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            margin: auto;
        }

        >div {
            height: 100%;
            position: absolute;
            left: 66px;

            .live_autor_name {
                span {
                    height: 15px;
                    margin-right: 4px;
                }

                img {
                    width: 18px;
                    height: 18px;
                }
            }

            .live_autor_time {
                height: 11px;
                color: #999999;
                font-size: 12px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                margin-top: 7px;

                span:nth-of-type(2) {
                    margin-left: 5px;
                }
            }
        }

        button {
            width: 65px;
            height: 26px;
            background-color: #EA5E58;
            border-radius: 4px;
            color: #ffffff;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            line-height: 26px;
            border: none;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
        }
    }

    .live_brief {
        font-size: 15px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #898989;
    }

    .live_content_cont {
        margin-top: 34px;
        overflow: hidden;
        font-size: 15px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
    }

    .live_like {
        margin: 39px 0 30px 0;
        position: relative;
        height: 72px;

        >img {
            position: absolute;
            width: 45px;
            height: 45px;
            left: 0;
            right: 0;
            margin: auto;
        }

        >span {
            width: 16px;
            height: 11px;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            top: 55px;
            color: #898989;
            font-size: 14px;
            font-family: PingFang-SC-Medium;
            font-weight: 500;
        }
    }

    .live_statement {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #BFC0C1;
    }

    .live_contactUs {
        height: 31px;
        margin-top: 24px;

        >a {
            position: absolute;
            right: 0;
            display: inline-block;
            width: 93px;
            height: 31px;
            background: rgba(248, 247, 245, 1);
            border-radius: 15px;
            color: #282828;
            font-size: 12px;
            text-align: center;
            background-color: #F8F7F5;
            line-height: 31px;

            >img {
                width: 5px;
                height: 8px;
            }
        }
    }
}

.live_unfold {
    height: 78px;
    width: 100%;
    // opacity: .04;
    position: absolute;
    bottom: -30px;
    background-image: linear-gradient(-180deg, hsla(0, 0%, 100%, 0), #fff);
}

.live_unfold_down {
    content: '';
    background-image: url(https://cdn.aigupiao.com/static/wrap/img/live_detail_ico5.png);
    background-repeat: no-repeat;
    background-size: contain;
    height: 16px;
    width: 16px;
    position: absolute;
    z-index: 99;
    animation: unfold-arrow-animation 300ms infinite alternate;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
}

@keyframes unfold-arrow-animation {
    from {
        bottom: 0;
    }

    to {
        bottom: 5px;
    }
}




.articles_goodRecommend {
    padding-top: 24px;

    .articles_commonTitle {
        margin-bottom: 6px;
    }

    >ul {
        padding: 0 14px 33px 14px;

        >li {
            .border-1px(#E8E8E8);

            &:last-child:after {
                border-bottom: 0;
            }

            padding: 14px 0 15px 0;

            .articles_goodRecommend_top {
                h3 {
                    font-size: 16px;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    color: #222222;
                    line-height: 20px;
                    padding-bottom: 12px;
                }

                >p {}
            }

        }
    }
}

.articles_goodRecommend_bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    width: 100%;

    .recommend_bottom_left {

        img {
            width: 30px !important;
            height: 30px;
            border-radius: 30px;
        }

        a {
            height: 15px;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: #939393;
            line-height: 15px;
            margin-left: 12px;

            .recommend_bottom_two {
                margin-left: 12px;
            }
        }
    }

    .recommend_bottom_right {
        color: #FE484A;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        line-height: 15px;
        border-radius: 4px;
        color: #FE484A;
        padding: 2px 7px;

        a {
            color: #FE484A !important;

            img {
                width: 94px;
                height: 20px;
            }
        }
    }
}
</style>